export interface PerformanceMetric {
  id: number;
  group_performance_metric_id: number;
  description: string;
  index: number;
}
